export function checkedEmailTaskCase(value,suggestionId,taskId) {
  const source=value?.source;
  const valid=value?.id===suggestionId&&value?.task_id===taskId&&value.read_only===true&&value.external_completion_verified===false&&
    ["saved","in_progress","done","unverified"].includes(value.state)&&typeof value.next_step==="string"&&value.next_step.length>0&&value.next_step.length<=500&&
    ["current","changed","unavailable"].includes(source?.state)&&
    (source.state!=="current"||(typeof source.title==="string"&&source.title.length<=300&&/^\/inbox\?email=[^&#?]+$/.test(source.path)))&&
    Array.isArray(value.milestones)&&value.milestones.length>=1&&value.milestones.length<=2&&value.milestones.every(item=>
      ["approved","current_state"].includes(item?.kind)&&typeof item.label==="string"&&item.label.length<=200&&
      (item.at===null||typeof item.at==="string"&&Number.isFinite(Date.parse(item.at))));
  if(!valid)throw new Error("Asian taustaa ei voitu varmistaa.");
  return value;
}
